<template>
    <div class="container-fluid px-0 bg-about animated fadeIn slow" style="height: 100vh;">

        <div class="lime-bar-footer fixed-bottom"></div>
        <div class="container font-italic" style="position: relative; z-index: 0;">
            <div v-if="userRole">
                <div v-if="userRole ==='admin' || userRole === 'driver'|| userRole === 'industry'" class="mb-5 pb-5">
                    <div class="d-flex flex-column">
                        <theHeader></theHeader>
                        <div class="font-italic font-weight-bold text-uppercase mt-0 mt-md-5 pt-5 title">we know all
                            about you...
                        </div>
                        <div class="lime-bar-diag">
                            <img src="../assets/img/Asset_3.png" alt="" class="">
                        </div>
                        <div class="sub-title text-uppercase font-xs font-italic">but do you know about rufus?</div>
                        <div class="align-self-center my-auto">
                            <div class="text-left pt-5 mt-2" style="background: transparent;">
                                <p><strong>RUFUS</strong>. It’s an attitude. A way of doing things.</p>

                                <p>It became known in the 1960s, a time remembered for racers who lived to be racers,
                                    and a sport that somehow felt more pure. We had a deep appreciation for what made
                                    all forms of motorsport great, not just those with the most visibility. We
                                    celebrated drivers for excellence in top categories, while equally celebrating the
                                    purity of their competitive spirit... and we made legends out of those who held the
                                    belief that, on their day, they could give it hell and win any race, in any car, at
                                    any track.</p>

                                <p>Motorsport from this time was different. It was greater than the sum of its
                                    individual parts. And it brought us together.</p>

                                <p>RUFUS is about bringing back that feeling of connectedness, because that’s how it
                                    should be. It’s about empowering great drivers to showcase their skills wherever
                                    they want, because that’s fucking awesome. And it’s about highlighting the most
                                    meaningful and inspiring parts of motorsport in a new way, because that’s how we
                                    make sure it matters going forward.</p>

                                <p>This is the ultimate driver’s championship, for racers, by racers. All the events
                                    that matter from across global motorsport categories are carefully curated and
                                    bundled together in a single system. Drivers are rewarded for commitment and
                                    competitiveness in their home championships, but challenged to venture outside their
                                    specialty for the universal recognition only shared by our sport’s legends.</p>

                                <p>RUFUS has always been around. You don’t have to know our exact formula to know who
                                    the great RUFUS champions are. All we’re doing is giving it some structure for the
                                    modern era. It’s time for the elite from across disciplines to be recognized without
                                    qualifiers. It’s time we appreciate all that makes motorsport as whole so
                                    incredible.</p>

                                <p>It’s time to bring the attitude back.</p>

                                <p>Welcome to RUFUS. <strong>Your legacy awaits</strong>.</p>

                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <TheHeader/>
                    <h1 class="mt-5 pt-5">You do not have the correct credentials to view this page...</h1>
                </div>

            </div>
            <div v-else class="pt-5">
                <TheHeader class="mb-5 pb-5"/>
                <div v-if="userRole === null" class="mt-5 pt-5">
                    <h1>You must be logged in with the correct credentials to view this page...</h1>
                </div>
                <div v-if="userRole === 'public'" class="mt-5 pt-5">
                    <h1>You do not have the correct credentials to view this page...</h1>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import logo from '@/components/RufusLogo'
    import firebase from 'firebase'
    import TheHeader from '../components/TheHeader';

    export default {
        name      : 'story',
        components: {
            logo,
            firebase,
            TheHeader
        },
        computed  : {
            userRole () {
                return this.$store.getters.getUserRole;
            }
        },
        watch     : {
            userRole (val) {
                if ( val === 'admin' || val === 'driver' || val === 'industry' ) {
                    // console.log('admin or driver...');
                    this.$router.push({path: '/story'})
                } else {
                    // console.log('not admin or driver');
                    this.$router.push({path: '/login'})
                }
            }
        },
        created () {
            this.$store.dispatch('getUserAccount')
        }
    }
</script>

<style scoped lang="scss">
    @import '../assets/css/_vars.scss';

    .bg-about {
        background-image: url(../assets/img/about.png);
        background-position: center;
        background-repeat: no-repeat; /* Do not repeat the image */
        background-size: cover; /* Resize the background image to cover the entire container */
        background-attachment: fixed;
        overflow-x: auto;
    }

    .title {
        margin-left: -170px;
    }

    .sub-title {
        margin-left: 300px;
    }

    @media all and (max-width: 576px) {

        .title {
            font-size: 17px;
            padding-left: 100px;
        }

        p {
            margin-bottom: 10px;
            font-size: 14px;
        }

        .sub-title {
            margin-left: 150px;
        }
    }

    @media all and (min-width: 992px) and (max-width: 1199px) {

    }
</style>
